import { render } from "./BannerEffective.vue?vue&type=template&id=4df50dad&scoped=true"
import script from "./BannerEffective.vue?vue&type=script&lang=js"
export * from "./BannerEffective.vue?vue&type=script&lang=js"

import "./BannerEffective.vue?vue&type=style&index=0&id=4df50dad&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df50dad"]])

export default __exports__